import { rootInstance } from '../axiosConfig';
import { handleRequestWithAuth } from '../refreshService';

const API_URL = 'blog-publicaciones/';

export interface CategoriaPublicacion {
    id: number;
    nombre: string;
    slug: string;
    descripcion: string | null;
    creado_en: string;
}

export interface Publicacion {
    id: number;
    titulo: string;
    slug: string;
    subtitulo: string | null;
    contenido: string;
    imagen: string | null;
    url_imagen: string | null;
    categoria: CategoriaPublicacion | null;
    categoria_id?: number | null; 
    autor: number;
    nombre_autor: string;
    es_destacado: boolean;
    estado: 'borrador' | 'publicado';
    fecha_publicacion: string | null;
    creado_en: string;
    actualizado_en: string;
}

export const fetchPublicaciones = async (params?: {
    estado?: 'borrador' | 'publicado';
    es_destacado?: boolean;
    categoria__slug?: string;
    search?: string;
    ordering?: string;
}): Promise<Publicacion[]> => {
    return handleRequestWithAuth(async () => {
        const response = await rootInstance.get<Publicacion[]>(API_URL, { params });
        return response.data;
    });
};

export const fetchDestacados = async (): Promise<Publicacion[]> => {
    // No es necesario handleRequestWithAuth si es público; puedes usar rootInstance directamente
    const response = await rootInstance.get<Publicacion[]>(API_URL, {
        params: { es_destacado: true }
    });
    return response.data;
};

export const fetchPublicacionPorSlug = async (slug: string): Promise<Publicacion> => {
    return handleRequestWithAuth(async () => {
        const response = await rootInstance.get<Publicacion>(`${API_URL}${slug}/`);
        return response.data;
    });
};
